var _a, _b;
import { isTst1 } from '../lib/environment';
import { Option, pipe, ReadonlyRecord } from 'effect';
const CHATNITE_AUTH_URL = isTst1
    ? 'https://chatnite-test.spotify.net/graphql'
    : 'https://chatnite.spotify.com/graphql';
const CHATNITE_UNAUTH_URL = isTst1
    ? 'https://chatnite-unauth-test.spotify.net/graphql'
    : 'https://chatnite-unauth.spotify.com/graphql';
const getEnv = (key) => pipe(process.env, ReadonlyRecord.get(key), Option.getOrUndefined);
export const AUTH_ENDPOINT = (_a = getEnv('NEXT_PUBLIC_CHATNITE_ENDPOINT')) !== null && _a !== void 0 ? _a : CHATNITE_AUTH_URL;
export const UNAUTH_ENDPOINT = (_b = getEnv('NEXT_PUBLIC_CHATNITE_ENDPOINT')) !== null && _b !== void 0 ? _b : CHATNITE_UNAUTH_URL;
